(function() { module.exports = this["wp"]["deprecated"]; }());